module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.18a127e.woff";